import * as bcrypt from 'bcryptjs'; // Use bcryptjs instead!

// --- PASTE THE HASH GENERATED BY `deploy/generate-hash.js` (using the 'bcrypt' package) ---
// bcrypt and bcryptjs produce compatible hashes.
const STORED_HASH = '$2b$10$2j.Wf.bBY0Pc2oIbbzP6PeuryTdScAyOgl2gSQLZcDURAxDTMG9pa';

/**
 * Verifies a submitted password against the stored bcrypt hash **IN THE BROWSER**.
 * WARNING: This approach is insecure as the hash and logic are exposed client-side.
 *
 * @param submittedPassword The plaintext password attempt.
 * @returns A Promise that resolves to true if the password matches the stored hash, false otherwise.
 */
export async function verifyPassword(submittedPassword: string): Promise<boolean> {
  if (!submittedPassword) {
    // Avoids errors in bcryptjs if password is empty, returns false as it can't match.
    return false;
  }

  try {
    // bcryptjs.compare works similarly to bcrypt.compare
    // It's asynchronous because hashing is computationally intensive.
    console.log('Attempting comparison (client-side)...'); // Log for debugging
    const isMatch = await bcrypt.compare(submittedPassword, STORED_HASH);
    console.log('Comparison result:', isMatch); // Log for debugging
    return isMatch;
  } catch (error) {
    console.error('Error comparing password (client-side):', error);
    // It's generally safer to return false on error during authentication.
    return false;
  }
}
